import { Button, Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { FreeTrialDialog } from 'components/shared/free-trial-dialog';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { GetUrlBuilderData } from 'store/url-builder';
import dashedButtonStyle from 'styles/buttons/dashed-button.module.scss';
import { AppStoresDialog } from './app-stores-dialog';

export interface AppStoresProps {
    builderType: string;
    isFree?: boolean | null;
}
export const AppStores = ({ builderType, isFree = null }: AppStoresProps) => {
    const [openDialog, setOpenDialog] = useState(false);
    const builderData = useSelector(GetUrlBuilderData);
    const [freeTrialDialog, setFreeTrialDialog] = useState(false);
    const openFreeTrialDialog = () => setFreeTrialDialog(true);
    const handleCloseFreeTrialDialog = () => setFreeTrialDialog(false);
    return (
        <Grid item container xs={12}>
            <Grid item xs={12}>
                <Button onClick={!isFree ? () => setOpenDialog(true) : openFreeTrialDialog} classes={{ root: dashedButtonStyle.root }} fullWidth>
                    <AddIcon /> {builderData.appStores.length > 0 ? 'Add/Edit Store' : 'Add Store'}
                </Button>
            </Grid>
            {openDialog && <AppStoresDialog isOpen={openDialog} onClose={() => setOpenDialog(false)} builderType={builderType} />}
            {freeTrialDialog && <FreeTrialDialog isOpen={freeTrialDialog} onClose={handleCloseFreeTrialDialog} />}
        </Grid>
    );
};
